import { Button } from '@/components/form/Button';
import { ButtonVariant } from '@/components/form/buttonHelper';
import { Loading } from '@/components/loading/Loading';
import { Modal } from '@/components/modal/Modal';
import { ModalProps } from '@/components/modal/useModal';
import { Card } from '@/components/sections/Card';
import { PurchaseOrderBundle } from '@/services/api/contracts/catalog/bundles';
import { useDeletePurchaseOrderBundle } from '@/services/api/hooks/bundles';

import { FunctionComponent, Suspense, useState } from 'react';
import { useParams } from 'react-router';

const DeletePurchaseOrderModal: FunctionComponent<ModalProps<{ purchaseOrder: PurchaseOrderBundle }>> = props => {
  const DeletePurchaseOrder = () => {
    const order = props.props?.purchaseOrder;
    const { partnerId, companyId } = useParams();

    if (!(partnerId && companyId && order)) throw new Error('Missing params');

    const deletePurchaseOrder = useDeletePurchaseOrderBundle();

    const [loading, setLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState<string>('');

    const onDelete = async () => {
      setLoading(true);
      setErrorMessage('');

      try {
        await deletePurchaseOrder.mutateAsync({
          mspId: partnerId,
          customerId: companyId,
          id: order.id
        });
        props.close();
      } catch (error) {
        setErrorMessage('Unable to delete order.');
      }

      setLoading(false);
    };

    return (
      <Card className="w-full p-8 space-y-2">
        <Modal.Controls {...props}>
          <h1 className="text-2xl font-bold">Delete</h1>
        </Modal.Controls>

        <div className="space-y-6">
          <p>
            Are you sure you want to delete: <span className="font-semibold">{order.name}?</span>
          </p>
          {errorMessage && <p className="text-red-500">{errorMessage}</p>}
          <div className="flex gap-2 justify-between">
            <Button onClick={props.close}>Cancel</Button>
            <Button type="button" variant={ButtonVariant.Destructive} loading={loading} onClick={onDelete}>
              Delete
            </Button>
          </div>
        </div>
      </Card>
    );
  };

  return (
    <Modal className="md:max-w-xl" {...props}>
      <Suspense fallback={<Loading />}>
        <DeletePurchaseOrder />
      </Suspense>
    </Modal>
  );
};

export default DeletePurchaseOrderModal;
